<template>
	<div>

		<div class="main-container">
			<div class="navBarTest">
				<Navbar />
			</div>

			<!-- Page Title Banner -->
			<div class="secondary-title-wrapper col-lg-12" style="border-bottom: solid #007cc3">
				<h1 class="h3 my-0 mx-lg-5 secondary-title">{{ $t('demo.mainTitle') }}</h1>
			</div>

			<!-- Hero Section: headline + benefits LEFT | form RIGHT -->
			<div class="ads-hero-section mx-auto px-lg-5 px-3 pt-5 pb-0" style="max-width: 1500px">
				<div class="row align-items-stretch">
					<div class="col-lg-6 mb-4 mb-lg-0 d-flex flex-column pr-2 pr-sm-4">
						<p class="ads-category-label">{{ $t('demo.topPill') }}</p>
						<h2 class="ads-hero-title">{{ $t('demo.discover') }}</h2>
						<p class="ads-hero-sub">{{ $t('demo.mainText') }}</p>

						<ul class="ads-benefits-list mt-2">
							<li v-for="(b, i) in $t('demo.checks')" :key="'b-' + i">
								<span class="benefit-icon">✓</span> {{ b }}
							</li>
						</ul>

						<div class="ads-trust-logos mt-4 d-flex align-items-center flex-wrap">
							<span class="trust-badge">Flashforge</span>
							<span class="trust-badge">WaxJet</span>
							<span class="trust-badge">MultiJet</span>
							<span class="trust-badge">{{ $t('navBar.jewelry') }}</span>
						</div>

						<div class="ads-hero-img-wrapper mt-auto pt-4">
							<img
								src="../assets/img/3d/meeting-no-background.png"
								alt="Solution d'impression art graphique Groupe A&A"
								class="ads-hero-img"
							/>
						</div>
					</div>

					<div class="col-lg-6" id="formulaire">
						<div class=" mb-4">
							<ContactForm :boolEmbeded="true" :ctaText="$t('demo.subTitle')" use-shadow="true"
							 :serviceOptions="[{ value: $t('demo.formOption1'), label: $t('demo.formOption1') } ]"  />
						</div>
					</div>
				</div>
			</div>

			<!-- Products Section -->
			<div class="ads-products-section py-5 px-lg-5 px-3" style="background: #f7f9fb;">
				<div style="max-width: 1400px;" class="mx-auto">
					<h2 class="text-center ads-section-title mb-2">{{ $t('demo.expertise') }}</h2>
					<div class="d-flex" style="width:100%; justify-content: center;">
						<p style="max-width:600px" class="text-center ads-section-sub mb-5">{{ $t('demo.expertiseText') }}</p>
					</div>

					<div class="row">
						<!-- Jewelry -->
						<div class="col-6 col-lg-3 mb-4">
							<router-link :to="$t('links.accueil')" class="ads-product-card h-100">
								<img class="ads-product-img" src="../assets/img/3d/510-small.png"  />
								<div class="ads-product-body">
									<p class="ads-product-name">Flashforge Waxjet 510</p>
									<span class="ads-product-link">{{ $t('demo.learnMore') }} →</span>
								</div>
							</router-link>
						</div>
						<!-- Jewelry -->
						<div class="col-6 col-lg-3 mb-4">
							<router-link :to="$t('links.jewelry')" class="ads-product-card h-100">
								<img class="ads-product-img" src="../assets/img/3d/ring-half.png"  />
								<div class="ads-product-body">
									<p class="ads-product-name">{{ $t('navBar.jewelry') }}</p>
									<span class="ads-product-link">{{ $t('demo.learnMore') }} →</span>
								</div>
							</router-link>
						</div>
						<!-- wj51c -->
						<div class="col-6 col-lg-3 mb-4">
							<router-link :to="$t('links.wj51c')" class="ads-product-card h-100">
								<img class="ads-product-img" src="../assets/img/3d/wj51c-small.png"  />
								<div class="ads-product-body">
									<p class="ads-product-name">Flashforge WJ51C</p>
									<span class="ads-product-link">{{ $t('demo.learnMore') }} →</span>
								</div>
							</router-link>
						</div>
						<!-- Contact Us -->
						<div class="col-6 col-lg-3 mb-4">
							<router-link :to="$t('links.contactUs')" class="ads-product-card h-100">
								<img class="ads-product-img" src="../assets/img/3d/contact-small.png" />
								<div class="ads-product-body">
									<p class="ads-product-name">{{ $t('demo.question') }}</p>
									<span class="ads-product-link">{{ $t('navBar.contactUs') }} →</span>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>

			<!-- Why Groupe A&A Section -->
			<div class="ads-why-section py-5 px-lg-5 px-3">
				<div style="max-width: 1400px;" class="mx-auto">
					<h2 class="text-center ads-section-title mb-5">{{ $t('demo.whyChoose') }}</h2>
					<div class="row text-center">
						<div class="col-md-4 mb-4">
							<div class="why-card">
								<div class="why-icon">🎓</div>
								<h3 class="why-card-title">{{ $t('demo.dedicated') }}</h3>
								<p class="why-card-text">{{ $t('demo.dedicatedText') }}</p>
							</div>
						</div>
						<div class="col-md-4 mb-4">
							<div class="why-card">
								<div class="why-icon">🛠️</div>
								<h3 class="why-card-title">{{ $t('demo.solutions') }}</h3>
								<p class="why-card-text">{{ $t('demo.solutionsText') }}</p>
							</div>
						</div>
						<div class="col-md-4 mb-4">
							<div class="why-card">
								<div class="why-icon">📍</div>
								<h3 class="why-card-title">{{ $t('demo.support') }}</h3>
								<p class="why-card-text">{{ $t('demo.supportText') }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Bottom CTA Banner -->
			<div class="ads-cta-banner px-3 px-lg-5 py-5">
				<div class="ads-cta-inner text-center">
					<h2 class="ads-cta-title">{{ $t('demo.mainTitle') }}</h2>
					<a href="#formulaire" class="ht-btn ht-btn-md mt-3">{{ $t('demo.book') }}</a>
				</div>
			</div>
		</div>

		<div>
			<FooterMain />
		</div>
	</div>
</template>

<script>
	import Navbar from '../components/Navbar.vue'
    import ContactForm from '../components/ContactForm.vue'
	import FooterMain from '../components/FooterMain.vue'

	export default {
		name: 'BookDemo',
		components: {
			Navbar,
            ContactForm,
			FooterMain
		},
		metaInfo(){
			return {
				title: this.$i18n.t('tabTitle.demo'),
				meta: [
					{ "name": "description", "content":  this.$i18n.t('meta.description.demo') },
					{ "name": "theme-color", "content": "#007BFF;" }
				]
			}
		},
		created(){
			if(typeof window.gtag !== 'undefined'){
				window.gtag('config', process.env.VUE_APP_GTAG_UA, {
						'page_title' : this.$i18n.t('tabTitle.demo'),
						'page_path': this.$i18n.t('links.demo')
				});
				window.gtag('config', process.env.VUE_APP_GTAG_G, {
						'page_title' : this.$i18n.t('tabTitle.demo'),
						'page_path': this.$i18n.t('links.demo')
				});
			}
			if(typeof window.fbq !== 'undefined'){
				window.fbq('track', 'PageView');
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../assets/scss/variabls.scss';
	@import '../assets/scss/elements/page-equipements.scss';

	/* ── Hero ─────────────────────────────────────────── */
	.ads-category-label {
		display: inline-block;
		align-self: flex-start;
		background-color: #007cc3;
		color: #fff;
		font-size: 0.72rem;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 1.5px;
		padding: 4px 14px;
		border-radius: 20px;
		margin-bottom: 16px;
	}

	.ads-hero-title {
		font-size: 1.8rem;
		font-weight: 800;
		color: #1a1a2e;
		line-height: 1.25;

		@media (max-width: 768px) { font-size: 1.5rem; }
	}

	.ads-hero-sub {
		font-size: 1.05rem;
		color: #555;
		margin-top: 12px;
		line-height: 1.7;
	}

	.ads-benefits-list {
		list-style: none;
		padding: 0;
		margin: 0;

		li {
			display: flex;
			align-items: flex-start;
			gap: 10px;
			font-size: 0.97rem;
			color: #333;
			padding: 7px 0;
			border-bottom: 1px solid #f0f0f0;

			&:last-child { border-bottom: none; }
		}
	}

	.benefit-icon {
		color: #007cc3;
		font-weight: 800;
		flex-shrink: 0;
		margin-top: 1px;
	}

	.ads-trust-logos {
		gap: 10px;
	}

	.trust-badge {
		display: inline-block;
		border: 1.5px solid #c8dcea;
		border-radius: 6px;
		padding: 4px 14px;
		font-size: 0.82rem;
		font-weight: 700;
		color: #007cc3;
		background: #f0f7fd;
		letter-spacing: 0.5px;
	}

	/* ── Hero image ─────────────────────────────────── */
	.ads-hero-img-wrapper {
		flex: 1;
		display: flex;
		align-items: flex-end;
		min-height: 0;
	}

	.ads-hero-img {
		width: 100%;
		max-height: 340px;
		object-fit: contain;
		object-position: bottom center;
		display: block;
	}

	/* ── Form card ───────────────────────────────────── */
	.ads-form-card {
		background: #fff;
		border: 2px solid #007cc3;
		border-radius: 12px;
		padding: 28px 24px 16px;
		box-shadow: 0 8px 32px rgba(0, 124, 195, 0.10);
	}

	.ads-form-title {
		font-size: 1.15rem;
		font-weight: 700;
		color: #1a1a2e;
		text-align: center;
		margin-bottom: 4px;
	}

	/* ── Section titles ──────────────────────────────── */
	.ads-section-title {
		font-size: 1.6rem;
		font-weight: 700;
		color: #1a1a2e;
		position: relative;

		&::after {
			content: '';
			display: block;
			width: 60px;
			height: 3px;
			background: #007cc3;
			margin: 12px auto 0;
		}
	}

	.ads-section-sub {
		color: #666;
		font-size: 0.97rem;
	}

	/* ── Product cards ───────────────────────────────── */
	.ads-product-card {
		display: flex;
		flex-direction: column;
		background: #fff;
		border: 1px solid #e0e0e0;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
		text-decoration: none;
		cursor: pointer;
		color: inherit;
		transition: transform 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 8px 24px rgba(0, 124, 195, 0.14);
			text-decoration: none;
			color: inherit;
		}
	}

	.ads-product-img {
		width: 100%;
		height: 180px;
		object-fit: contain;
		padding: 8px;
		display: block;
	}

	.ads-product-body {
		padding: 14px 16px;
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		border-top: 1px solid #e0e0e0;
	}

	.ads-product-name {
		font-size: 0.9rem;
		font-weight: 700;
		color: #1a1a2e;
		margin-bottom: 8px;
		line-height: 1.4;
	}

	.ads-product-link {
		font-size: 0.82rem;
		font-weight: 600;
		color: #007cc3;
	}

	/* ── Why cards ───────────────────────────────────── */
	.why-card {
		padding: 28px 20px;
		border: 1px solid #e8edf2;
		border-radius: 10px;
		height: 100%;
		background: #fff;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
	}

	.why-icon {
		font-size: 2.2rem;
		margin-bottom: 12px;
	}

	.why-card-title {
		font-size: 1rem;
		font-weight: 700;
		color: #1a1a2e;
		margin-bottom: 8px;
	}

	.why-card-text {
		font-size: 0.88rem;
		color: #666;
		line-height: 1.65;
		margin: 0;
	}

	/* ── CTA banner ──────────────────────────────────── */
	.ads-cta-banner {
		background: linear-gradient(135deg, #007cc3 0%, #005a9e 100%);

		.ht-btn {
			background-image: none;
			background-color: #fff;
			color: #007cc3;
			font-weight: 700;

			&:hover, &:active, &:focus {
				background-image: none;
				background-color: rgba(255, 255, 255, 0.88);
				color: #005a9e;
				transform: translateY(-3px);
			}
		}
	}

	.ads-cta-inner {
		max-width: 700px;
		margin: 0 auto;
	}

	.ads-cta-title {
		font-size: 1.6rem;
		font-weight: 800;
		color: #fff;
		margin-bottom: 10px;
	}

	.ads-cta-text {
		font-size: 0.97rem;
		color: rgba(255, 255, 255, 0.88);
		margin: 0;
	}

	#formulaire {
		scroll-margin-top: 150px; /* adjust to your header height */
	}

</style>